import React from 'react';
import { motion } from 'framer-motion';
export function ClosingCTASection() {
  return <section className="w-full" data-id="element-1">
      {/* Part 1: Positioning Close */}
      <div className="bg-[#F9F5EF] py-24 px-6 md:py-32 text-center" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-light text-[#2C2C2C] mb-12 leading-tight" data-id="element-4">
            Planning Is Emotional. <br data-id="element-5" />
            <span className="italic" data-id="element-6">Your System Should Be Stable.</span>
          </h2>

          <div className="space-y-6 mb-12" data-id="element-7">
            <p className="text-xl font-serif text-[#2C2C2C]" data-id="element-8">
              Your wedding deserves structure.
            </p>
            <p className="text-xl font-serif text-[#2C2C2C]" data-id="element-9">
              Your time deserves clarity.
            </p>
            <p className="text-xl font-serif text-[#2C2C2C]" data-id="element-10">
              Your vision deserves organization.
            </p>
          </div>

          <div className="w-12 h-[1px] bg-[#C4A882] opacity-50 mx-auto mb-8" data-id="element-11"></div>

          <p className="text-lg text-[#6B8F64] font-light" data-id="element-12">
            The Complete Wedding Planner was designed to support you — not
            overwhelm you.
          </p>
        </motion.div>
      </div>

      {/* Part 2: Final CTA */}
      <div id="pricing" className="bg-[#8FAF88] py-24 px-6 text-center" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto" data-id="element-14">
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-6" data-id="element-15">
            Begin Planning With Structure and Confidence
          </h2>

          <p className="text-lg md:text-xl text-[#F9F5EF] font-light mb-4 max-w-2xl mx-auto" data-id="element-16">
            When you remove chaos, you create space for joy.
          </p>

          <p className="text-base text-[#F9F5EF]/80 font-light mb-10 max-w-xl mx-auto" data-id="element-17">
            Secure your digital planner today and move forward with clarity.
          </p>

          {/* Pricing */}
          <div className="flex items-center justify-center gap-4 mb-10" data-id="element-18">
            <span className="text-[#F9F5EF]/50 text-lg font-light line-through" data-id="element-19">
              $37.00
            </span>
            <span className="text-white text-4xl md:text-5xl font-serif" data-id="element-20">
              $19.95
            </span>
            <span className="bg-white/20 text-white text-xs uppercase tracking-widest px-3 py-1 font-medium" data-id="element-21">
              Save 46%
            </span>
          </div>

          <motion.button whileHover={{
          scale: 1.05,
          backgroundColor: '#FDFAF6'
        }} whileTap={{
          scale: 0.98
        }} className="bg-white text-[#8FAF88] px-12 py-5 text-sm uppercase tracking-[0.2em] font-medium shadow-lg hover:shadow-xl transition-all duration-300" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'The Complete Wedding Planner',
              content_type: 'product',
              value: 19.95,
              currency: 'USD'
            });
          }
          window.open('https://www.novarapress.com/cart/46313756262540:1', '_blank');
        }} data-id="element-22">
            Add to Cart
          </motion.button>
        </motion.div>
      </div>
    </section>;
}